export function toArray(responseData) {
  if (Array.isArray(responseData?.dados)) return responseData.dados;
  if (Array.isArray(responseData)) return responseData;
  return [];
}
